import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../../../context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from '../../../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../../../lib/types/types';
import { ForceTrue, NonRequired } from '../../../../../../../../../lib/validation/ValidationTypes';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import AntragSchema from '../../../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektBeschreibungAntragKreativwirtschaft: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm
				formStruc={formStrucFunktion(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default ProjektBeschreibungAntragKreativwirtschaft;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucFunktion = (_application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0011932730_e_Und_Konzeptionellen_Ansatz,
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0071138270_e_Ziele_Wollen_Sie_Erreichen,
					type: 'multiSelect',
				},
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0234590421_hen_Sie_Die_Jeweiligen_Ziele,
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0005956276_len_Sie_Und_Warum_Projektart,
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0000512644_Waehlen_Sie_Und_Warum_Format,
					type: 'multiSelect',
					placeholder: 'Bitte Format angeben',
				},
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0169418148_ragt_Werdensofern_Zutreffend,
					validation: [{ validateFunction: NonRequired }],
				},
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0228064142_en_Wen_Wollen_Sie_Ansprechen,
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0072569326_Der_Erwarteten_Teilnehmenden,
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0160591454_rganisatorisch_Unterstuetzen,
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0087130894_ie_Sich_Hierfuer_Entschieden,
					validation: [{ validateFunction: NonRequired }],
				},
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0140206852_Passen_Sie_Zu_Ihrem_Konzept,
					validation: [{ validateFunction: NonRequired }],
				},
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0255487902_Bereits_Foerderung_Erhalten,
					type: FORM_FIELDS_TYPES.radio,
					validation: [{ validateFunction: NonRequired }],
				},
				// Laut das Ticket HA-1985 und HA-1488 wird das Feld immer angezeigt
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0012777261_erentwickelt_Haben_Und_Warum,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucProjektBeschreibungAntragKreativwirtschaft = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Pruefstatus.path,
			P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStrucFunktion(application));
	return concat(formStrucFunktion(application));
};
